<template lang="pug">
  section.center
    transition( name="description" )
      .container
        .swipe
          .swiper-container
            .swiper-wrapper
              .swiper-slide 
                p VERY EASY
              .swiper-slide 
                p EASY
              .swiper-slide 
                p NORMAL
              .swiper-slide 
                p HARD
              .swiper-slide 
                p VERY HARD
            .swiper-menu
              .swiper-button-prev
                i( class="fas fa-angle-left" )
              .swiper-button-next
                i( class="fas fa-angle-right" )
        .menu
          .btn( @click="onFix" ) 
            p CONFIRM
          .btn.no( @click="onBack" ) 
            p BACK
</template>

<script>
import Swiper from "swiper";

export default {
  data() {
    return {
      slider: 0
    };
  },

  mounted() {
    let swipe = new Swiper(".swiper-container", {
      direction: "horizontal",
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });

    swipe.on("slideChangeTransitionStart", () => {
      this.slider = swipe.realIndex;
      this.$emit("onUpdate", this.slider);
    });
  },

  methods: {
    onFix() {
      this.$emit("onFix", this.slider);
    },

    onBack() {
      this.$emit("onBack");
    }
  }
};
</script>


<style scoped lang="scss">
@import "../../assets/swiper.scss";
</style>
